module.exports = "<div class=\"site-sidebar\">\n    <logo></logo>\n    <main-menu></main-menu>\n</div>\n<div class=\"sidebar-overlay\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/common-components/sidebar/sidebar.component.html
// module id = ./src/app/home/common-components/sidebar/sidebar.component.html
// module chunks = main